export enum IconAccountTypeEnum {
    AccountAvatar,
    AccountManagement,
    Recruit,
    LogOut,
    Plex,
    Details,
    Offer,
}
